import React, { useContext, VFC } from 'react';

import { Text } from 'mintel-react-ui';

import { DangerousB, DangerousH4 } from '/components/common';
import Context from '/components/Context';
import { StatContainerJson } from '/types';
import { BlockBackgroundContext } from '/utils/contexts';

import PanelColumn from './PanelColumn';

type StatColumnProps = Pick<StatContainerJson, 'background' | 'elements'> & {
  hide?: boolean;
};

const StatColumn: VFC<StatColumnProps> = ({
  background,
  elements = {},
  hide = false,
}) => {
  const { darkBg } = useContext(BlockBackgroundContext);

  return (
    <PanelColumn background={background} hide={hide}>
      <>
        {elements.title && !elements.title.hidden && (
          <Text.Heading4 darkBg={darkBg}>
            <DangerousH4>{elements.title.content}</DangerousH4>
          </Text.Heading4>
        )}
        {elements.stat && !elements.stat.hidden && (
          <Text.Body darkBg={darkBg}>
            <p>
              <DangerousB>{elements.stat.content}</DangerousB>
            </p>
          </Text.Body>
        )}
        {'context' in elements && (
          <Context content={elements.context.content} />
        )}
      </>
    </PanelColumn>
  );
};

export default StatColumn;
